// Equipo RE₿EL — i18n (ES/EN/SK) + datos de los fundadores.

const ES = {
  sectionTag: "// EQUIPO RE₿EL",
  title: "El equipo detrás de la revolución",
  subtitle: "Construyendo el futuro de la educación financiera descentralizada",
  founderRole: "Founder & Web3 Developer",
  ceoRole: "CEO & Professional Trader",
  connectOn: "Conectar en X",
  peterDesc:
    "Fundador y desarrollador de RE₿EL Academy. Responsable de la arquitectura de la plataforma, el despliegue del token $R₿L en Base L2, los contratos inteligentes ERC-20 y ERC-1155, y el ecosistema Web3 completo.",
  camiloDesc:
    "CEO de RE₿EL Academy y trader profesional de criptomonedas. Experto en análisis técnico, estrategias de trading y programación. Lidera la visión educativa y el crecimiento de la comunidad RE₿EL a nivel global.",
};

const EN = {
  sectionTag: "// RE₿EL TEAM",
  title: "The team behind the revolution",
  subtitle: "Building the future of decentralized financial education",
  founderRole: "Founder & Web3 Developer",
  ceoRole: "CEO & Professional Trader",
  connectOn: "Connect on X",
  peterDesc:
    "Founder and developer of RE₿EL Academy. Responsible for platform architecture, $R₿L token deployment on Base L2, ERC-20 and ERC-1155 smart contracts, and the complete Web3 ecosystem.",
  camiloDesc:
    "CEO of RE₿EL Academy and professional crypto trader. Expert in technical analysis, trading strategies and programming. Leads the educational vision and growth of the RE₿EL community globally.",
};

const SK = {
  sectionTag: "// TÍM RE₿EL",
  title: "Tím za revolúciou",
  subtitle: "Budujeme budúcnosť decentralizovaného finančného vzdelávania",
  founderRole: "Zakladateľ & Web3 vývojár",
  ceoRole: "CEO & Profesionálny trader",
  connectOn: "Spojiť sa na X",
  peterDesc:
    "Zakladateľ a vývojár RE₿EL Academy. Zodpovedný za architektúru platformy, nasadenie tokenu $R₿L na Base L2, smart kontrakty ERC-20 a ERC-1155 a kompletný Web3 ekosystém.",
  camiloDesc:
    "CEO RE₿EL Academy a profesionálny krypto trader. Expert na technickú analýzu, obchodné stratégie a programovanie. Vedie vzdelávaciu víziu a rast komunity RE₿EL na globálnej úrovni.",
};

const DE = {
  sectionTag: "// EQUIPO RE₿EL",
  title: "Das Team hinter der Revolution",
  subtitle: "Aufbau der Zukunft der dezentralisierten Finanzbildung",
  founderRole: "Founder & Web3 Developer",
  ceoRole: "CEO & Professional Trader",
  connectOn: "Auf X verbinden",
  peterDesc: "Gründer und Entwickler von RE₿EL Academy. Verantwortlich für die Plattformarchitektur, das Deployment des $R₿L-Tokens auf Base L2, die Smart Contracts ERC-20 und ERC-1155 sowie das gesamte Web3-Ökosystem.",
  camiloDesc: "CEO von RE₿EL Academy und professioneller Krypto-Trader. Experte in technischer Analyse, Trading-Strategien und Programmierung. Leitet die Bildungsvision und das globale Wachstum der RE₿EL-Community.",
};

const ZH_CN = {
  sectionTag: "// RE₿EL团队",
  title: "革命背后的团队",
  subtitle: "构建去中心化金融教育的未来",
  founderRole: "创始人兼Web3开发者",
  ceoRole: "首席执行官兼专业交易员",
  connectOn: "在X平台联系",
  peterDesc: "RE₿EL Academy创始人兼开发者。负责平台架构、Base L2上的$R₿L代币部署、ERC-20和ERC-1155智能合约以及完整的Web3生态系统。",
  camiloDesc: "RE₿EL Academy首席执行官兼专业加密货币交易员。技术分析、交易策略和编程专家。领导RE₿EL的教育愿景和全球社区增长。",
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const useTeamI18n = (lang) => ALL[lang] || ES;

export const TEAM_MEMBERS = [
  {
    id: "peter-stanga",
    name: "Peter Stanga",
    roleKey: "founderRole",
    descKey: "peterDesc",
    photo: "/team/peter-stanga.png",
    twitter: "https://x.com/ShibaInuWorld_",
    twitterHandle: "@ShibaInuWorld_",
  },
  {
    id: "camilo-rodriguez",
    name: "Camilo Rodríguez",
    roleKey: "ceoRole",
    descKey: "camiloDesc",
    photo: "/team/camilo-rodriguez.png",
    twitter: "https://x.com/CamiloR16798958",
    twitterHandle: "@CamiloR16798958",
  },
];
